import BatchInput from './src/main'
import TGBatchInput from './src/three-guarantees'

BatchInput.install = function (Vue) {
    Vue.component(BatchInput.name, BatchInput)
}

export default BatchInput;

export { TGBatchInput };